import { toast } from '@/shared/toast'
import { useSetFieldValue } from '@/shared/useSetFieldValue'
import type { Field } from './Fields/types'

export const useFieldReset = () => {
  const setFieldValue = useSetFieldValue()

  const resetField = async (field: Field) => {
    const res = await setFieldValue({ [field.propertyId]: { field, newValue: null } })

    if (!res.ok) {
      toast.error('Failed to save value, please try again.')
    }
  }

  return { resetField }
}
